export default __webpack_public_path__ + "static/media/congrats(1).4a3b0679.gif";